import { Spin } from 'antd';
import './LoadingComponent.scss';
import { Icon } from '../../icon/icon';

const LoadingComponent = ({ size, label, ...props }) => {
  return (
    <div {...props} className={'spin__container ' + props.className}>
      <Spin
        style={{
          width: `${size}px`,
          height: `${size}px`,
        }}
        indicator={
          <div
            className="spin"
            style={{
              width: `${size}px`,
              height: `${size}px`,
            }}
          >
            <div
              className="spin"
              style={{ width: `${size}px`, height: `${size}px` }}
            >
              <Icon.ICLoading />
            </div>
          </div>
        }
      />
      {label && <span className="spin__text">{label}</span>}
    </div>
  );
};

export default LoadingComponent;
